import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FieldConfig } from '../dynamic-form/dynamic-form-config.interface';
import { FormGroup, Validator } from '@angular/forms';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'date-input',
    templateUrl: './date-input.component.html',
    styleUrls: ['./date-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DatePipe]
})
export class DateInputComponent implements OnInit {

    @Input() field: FieldConfig;
    @Input() group: FormGroup;
    @ViewChild('picker') picker: MatDatepicker<any>;



    maxDate: Date = new Date();
    minDate: Date = new Date();

    constructor() { }

    ngOnInit(): void {
        if (this.field.dateConfig) {
            this.maxDate = this.field.dateConfig.maxDate;
            this.minDate = this.field.dateConfig.minDate;
        }
    }

    openPicker(): void {
        this.picker.open();
    }
    
    chosenYearHandler(normalizedYear: Moment) {
        const ctrlValue = this.group.controls[this.field.name].value === undefined ? normalizedYear : moment(this.group.controls[this.field.name].value);
        ctrlValue.year(normalizedYear.year());
        this.group.controls[this.field.name].setValue(ctrlValue);
    }

    chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = moment(this.group.controls[this.field.name].value);
        ctrlValue.month(normalizedMonth.month());
        this.group.controls[this.field.name].setValue(ctrlValue);
        if (this.field.dateConfig?.yearAndMonth) datepicker.close();
    }

    error(validation: any): boolean {
        const control = this.group.get(this.field.name);
        if (control && control.hasError(validation.name)) {
            return this.group.value[this.field.name] !== undefined;
        }
        return false;
    }
}
